module.exports = __webpack_public_path__ + "static/media/castledown-heavy.1bc10ef4.woff2";